import React, { Component } from "react";
import { NuLifeSpanCardBack } from './Cards/NuLifeSpanCard';
import { CVSCardBack } from './Cards/CVSCard';
import { WalmartCardBack } from './Cards/WalmartCard';
import AppleModal from "../Consumer/AppleModal";
import Resources from "../../resources.json";
import { userService } from "../../_services";

class CardBack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            carddata: {},
            groupdata: '',
            passtype: 'generic',
            deviceName: '',
            browserName: '',
            applePopup: false,
            shwoApplePopup: false,
            Primary_Gn: this.props.PrimaryGn,
            applePass: '',
            googlePass: '',
            popupApplePass: '',
            groupNumber: '',
            linkDisabled: false
        };
        this.appleWalletPopup = this.appleWalletPopup.bind(this);
        this.closeAppleWalletPopup = this.closeAppleWalletPopup.bind(this);
    }

    componentDidMount() {
        try {
            // get user device and browser name 
            let userAgent = window.navigator.userAgent;
            let devicetype = this.GetUserAgent(userAgent);
            let browsername = this.GetBrowserName(userAgent);
            let isSafari = (/Safari/.test(userAgent) && /Version/.test(userAgent) && !/CriOS/.test(userAgent))

            if (devicetype === "iPhone" && !isSafari) {
                this.setState({ deviceName: devicetype, browserName: browsername, shwoApplePopup: true });
            }
            else {
                this.setState({ deviceName: devicetype, browserName: browsername });
            }
        }
        catch {
        }
    }

    componentWillReceiveProps(props) {
        this.state.carddata = props.cardData ? props.cardData : { bin: '', pcn: '' }
        this.state.groupdata = props.groupData ? props.groupData : { groupnumber: '' }
    }

    appleGooglePassClick(passtype) {
        try {
            this.setState({ linkDisabled: true });
            let bin = this.props.cardData.bin;
            let pcn = this.props.cardData.pcn;
            let memberid = this.props.mId;
            let appname = Resources.ApplicationResources.pass[0].appname;
            let requestURL = '';
            requestURL = passtype === 'apple' ? Resources.ApplicationResources.pass[0].applelink : Resources.ApplicationResources.pass[0].googlelink;
            userService.apple_google_wallet_pass_link(requestURL, bin, pcn, this.props.groupNumber, memberid, this.state.passtype, appname)
                .then(
                    apidata => {
                        if (passtype === 'apple') {
                            window.open(apidata, '_blank');
                        } else {
                            window.open(apidata, '_blank');
                        }
                        this.setState({ linkDisabled: false });
                    }
                );
        }
        catch (error) {
        }
    }

    GetUserAgent(UserAgent_Raw) {
        if (/Mobi|Android/i.test(UserAgent_Raw)) {
            if (/iPhone|iPad|iPod/i.test(UserAgent_Raw)) {
                return 'iPhone';
            }
            else {
                return 'Android';
            }
        } else {
            return 'Desktop';
        }
    }

    GetBrowserName(UserAgent_Raw) {
        if (/Firefox/i.test(UserAgent_Raw)) {
            return 'Firefox';
        } else if (/Chrome/i.test(UserAgent_Raw)) {
            return 'Chrome';
        } else if (/Safari/i.test(UserAgent_Raw)) {
            return 'Safari';
        } else if (/MSIE|Trident/i.test(UserAgent_Raw)) {
            return 'Internet Explorer';
        } else if (/Edge/i.test(UserAgent_Raw)) {
            return 'Edge';
        } else if (/Opera|OPR/i.test(UserAgent_Raw)) {
            return 'Opera';
        } else if (/Brave/i.test(UserAgent_Raw)) {
            return 'Brave';
        } else if (/Vivaldi/i.test(UserAgent_Raw)) {
            return 'Vivaldi';
        } else if (/Yandex/i.test(UserAgent_Raw)) {
            return 'Yandex';
        } else if (/Chromium/i.test(UserAgent_Raw)) {
            return 'Chromium';
        } else {
            return 'Unknown';
        }
    }

    appleWalletPopup() {
        let userAgent = window.navigator.userAgent;
        if (this.state.deviceName === "iPhone" && !(/Safari/.test(userAgent) && /Version/.test(userAgent) && !/CriOS/.test(userAgent))) {
            this.setState({
                applePopup: true
            });
        }
        else {
            this.appleGooglePassClick('apple');
        }
    }

    closeAppleWalletPopup() {
        this.setState({ applePopup: false })
    }

    openAppleLink() {
        this.appleGooglePassClick('apple');
    }

    openGooglePass() {
        try {
            this.appleGooglePassClick('google');
        }
        catch (error) {
        }
    }

    render() {
        const cardType = this.state.carddata?.classnames;
        const memberId = this.props.mId || this.state.carddata?.mId || '';
        const groupNumber = this.props.groupNumber || this.state.groupdata?.groupnumber || '';
        
        if (cardType === 'cvs_card') {
            return <CVSCardBack />;
        }
        
        if (cardType === 'walmart_card') {
            return <WalmartCardBack />;
        }
        
        // Default: NuLifeSpan Rx card
        return (
            <>
                <NuLifeSpanCardBack 
                    groupNumber={groupNumber}
                    memberId={memberId}
                    isLinked={this.props.isLinked}
                    deviceName={this.state.deviceName}
                    browserName={this.state.browserName}
                    onAppleWalletClick={() => this.appleWalletPopup()}
                    onGoogleWalletClick={() => this.appleGooglePassClick('google')}
                    linkDisabled={this.state.linkDisabled}
                />
                {this.state.applePopup ? <AppleModal applePass={this.state.popupApplePass} closeModal={this.closeAppleWalletPopup.bind(this)} /> : null}
            </>
        );
    }
}

export default CardBack;
